import React, { useState } from 'react';
import { PlusIcon, EditIcon, TrashIcon } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Modal } from '../components/ui/Modal';
import { LenderForm } from '../components/LenderForm';
import { mockLenders } from '../data/mockData';
import { Lender } from '../types';
export function LenderManagement() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLender, setSelectedLender] = useState<Lender | undefined>();
  const handleCreateLender = (lenderData: Omit<Lender, 'id' | 'createdAt' | 'updatedAt'>) => {
    // In real app, this would create the lender
    console.log('Creating lender:', lenderData);
    setIsModalOpen(false);
  };
  const handleEditLender = (lender: Lender) => {
    setSelectedLender(lender);
    setIsModalOpen(true);
  };
  const handleUpdateLender = (lenderData: Omit<Lender, 'id' | 'createdAt' | 'updatedAt'>) => {
    // In real app, this would update the lender
    console.log('Updating lender:', selectedLender?.id, lenderData);
    setIsModalOpen(false);
    setSelectedLender(undefined);
  };
  const handleDeleteLender = (lenderId: string) => {
    if (confirm('Are you sure you want to delete this lender?')) {
      // In real app, this would delete the lender
      console.log('Deleting lender:', lenderId);
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedLender(undefined);
  };
  return <div className="space-y-6" data-id="element-385">
      <div className="flex items-center justify-between" data-id="element-386">
        <div data-id="element-387">
          <h1 className="text-3xl font-bold text-slate-900" data-id="element-388">
            Lender Management
          </h1>
          <p className="text-slate-600 mt-1" data-id="element-389">
            Manage lender accounts and information
          </p>
        </div>
        <Button variant="primary" onClick={() => setIsModalOpen(true)} data-id="element-390">
          <PlusIcon className="w-4 h-4 mr-2" data-id="element-391" />
          Add Lender
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-392">
        {mockLenders.map(lender => <Card key={lender.id} className="p-6" data-id="element-393">
            <div className="flex items-start justify-between mb-4" data-id="element-394">
              <h3 className="text-lg font-semibold text-slate-900" data-id="element-395">
                {lender.name}
              </h3>
              <div className="flex space-x-2" data-id="element-396">
                <button onClick={() => handleEditLender(lender)} className="text-slate-400 hover:text-slate-600 transition-colors" aria-label="Edit lender" data-id="element-397">
                  <EditIcon className="w-4 h-4" data-id="element-398" />
                </button>
                <button onClick={() => handleDeleteLender(lender.id)} className="text-slate-400 hover:text-red-600 transition-colors" aria-label="Delete lender" data-id="element-399">
                  <TrashIcon className="w-4 h-4" data-id="element-400" />
                </button>
              </div>
            </div>

            <div className="space-y-2" data-id="element-401">
              <div data-id="element-402">
                <p className="text-xs text-slate-600" data-id="element-403">FHA Sponsor ID</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-404">
                  {lender.fhaSponsorId}
                </p>
              </div>
              <div data-id="element-405">
                <p className="text-xs text-slate-600" data-id="element-406">VA Sponsor ID</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-407">
                  {lender.vaSponsorId}
                </p>
              </div>
              <div data-id="element-408">
                <p className="text-xs text-slate-600" data-id="element-409">Tax ID</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-410">
                  {lender.taxId}
                </p>
              </div>
              <div data-id="element-411">
                <p className="text-xs text-slate-600" data-id="element-412">Phone</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-413">
                  {lender.phone}
                </p>
              </div>
              <div data-id="element-414">
                <p className="text-xs text-slate-600" data-id="element-415">Email</p>
                <p className="text-sm font-medium text-slate-900 truncate" data-id="element-416">
                  {lender.email}
                </p>
              </div>
              <div data-id="element-417">
                <p className="text-xs text-slate-600" data-id="element-418">Address</p>
                <p className="text-sm font-medium text-slate-900" data-id="element-419">
                  {lender.address.city}, {lender.address.state}
                </p>
              </div>
            </div>
          </Card>)}
      </div>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal} title={selectedLender ? 'Edit Lender' : 'Add New Lender'} size="lg" data-id="element-420">
        <LenderForm lender={selectedLender} onSubmit={selectedLender ? handleUpdateLender : handleCreateLender} onCancel={handleCloseModal} data-id="element-421" />
      </Modal>
    </div>;
}